import axios from 'axios'
import { API_BACK_OFFICE_URL, API_BASE_URL, API_EXTERNAL_URL, SESSION_COOKIE_NAME } from '../constants'


export const ping = ({ url = API_BASE_URL, timeout=5000, isOnlineCallback, isOfflineCallback }) => {
  return new Promise(resolve => {
    const isOnline = () => {
      isOnlineCallback()
      resolve(true);
    }
    const isOffline = () => {
      isOfflineCallback()
      resolve(false);
    }

    const xhr = new XMLHttpRequest();

    xhr.onerror = isOnline;
    xhr.ontimeout = isOffline;
    xhr.onreadystatechange = () => {
      if (xhr.readyState === xhr.HEADERS_RECEIVED) {
        if (xhr.status) {
          isOnline();
        } else {
          isOffline();
        }
      }
    };

    xhr.open("GET", url);
    xhr.timeout = timeout;
    xhr.send();
  });
}


const client = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-Session-ID': SESSION_COOKIE_NAME
  },
  withCredentials: true
})

// const backCLients = axios.create({
//   baseURL: API_BACK_BASE_URL,
//   headers: {
//     'Content-Type': 'application/json'
//   }
// })

export const makeCall = (method, url, data = {}, headers = {}, params = {}, extra = {  withCredentials: true,
}
) => {
  return client.request({
    method,
    data,
    url,
    headers: {
      ...client.defaults.headers.common,
      ...headers
    },    params,
 
    ...extra
  })
}

// export const makeBackCall = (method, url, data = {}, headers = {}, params = {}, extra = {}) => {
//   return backCLients.request({
//     method,
//     data,
//     url,
//     headers,
//     params,
//     ...extra
//   })
// }


const externalClient = axios.create({
  baseURL: API_EXTERNAL_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-Session-ID': SESSION_COOKIE_NAME
  },
  withCredentials: true
})


export const makeExternalCall = (method, url, data = {}, headers = {}, params = {}, extra = {}) => {
  return externalClient.request({
    method,
    data,
    url,
    headers,
    params,
    ...extra
  })
}

const backOffice = axios.create({
  baseURL: API_BACK_OFFICE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})
